import config from '../../config';

export default {
  url: `${config.api.baseURL}/invite`,
  options: {
    method: 'POST'
  },
  transformer(data) {
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/api/invites/create.js